<template>
    <div class="modal-overlay">
        <div class="modal-content proc-modal-large">
            <h3>{{ props.nmEtapa }}</h3>

            <div v-if="msgAlerta" class="alert-error">
                {{ msgAlerta }}
            </div>

            <div v-if="isLoading" class="margin-top10">
                Carregando...
            </div>

            <div v-else class="proc-permissoes-grid">
                <div class="proc-permissoes-header perfil">Perfil</div>
                <div class="proc-permissoes-header">Consultar</div>
                <div class="proc-permissoes-header">Inserir dados</div>
                <div class="proc-permissoes-header">Anexar doc.</div>
                <div class="proc-permissoes-header">Analisar doc.</div>
                <div class="proc-permissoes-header">Avançar</div>
                <div class="proc-permissoes-header">Retornar</div>

                <template v-for="perfil in lsPerfil" :key="perfil.idperfil">
                    <div class="proc-permissoes-cell perfil">
                        {{ perfil.nmperfil }}
                    </div>

                    <div class="proc-permissoes-cell">
                        <input
                            type="checkbox"
                            v-model="perfil.ckconsultar"
                            true-value="S"
                            false-value="N"
                        />
                    </div>

                    <div class="proc-permissoes-cell">
                        <input
                            type="checkbox"
                            v-model="perfil.ckinserir_dados"
                            true-value="S"
                            false-value="N"
                        />
                    </div>

                    <div class="proc-permissoes-cell">
                        <input
                            type="checkbox"
                            v-model="perfil.ckanexar_doc"
                            true-value="S"
                            false-value="N"
                        />
                    </div>

                    <div class="proc-permissoes-cell">
                        <input
                            type="checkbox"
                            v-model="perfil.ckanalise_documentos"
                            true-value="S"
                            false-value="N"
                        />
                    </div>

                    <div class="proc-permissoes-cell">
                        <input
                            type="checkbox"
                            v-model="perfil.ckavancar"
                            true-value="S"
                            false-value="N"
                        />
                    </div>

                    <div class="proc-permissoes-cell">
                        <input
                            type="checkbox"
                            v-model="perfil.ckretornar"
                            true-value="S"
                            false-value="N"
                        />
                    </div>
                </template>
            </div>

            <div class="row-end margin-top10">
                <button type="button" class="btn-confirm" @click="salvarDados">
                    Salvar
                </button>

                <button type="button" class="btn-cancel" @click="$emit('close')">
                    Cancelar
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';

const isLoading = ref(false);
const msgAlerta = ref(null);
const lsPerfil = ref([]);

const emit = defineEmits(['close']);
const props = defineProps({
    idEtapa: {
        type: Number,
        default: 0
    },
    nmEtapa: {
        type: String,
        default: "Permissões de Acesso"
    },
});

function normalizarCheck(valor) {
    return valor === 'S' ? 'S' : 'N';
}

function possuiAlgumaPermissao(perfil) {
    return (
        perfil.ckconsultar === 'S' ||
        perfil.ckinserir_dados === 'S' ||
        perfil.ckanalise_documentos === 'S' ||
        perfil.ckanexar_doc === 'S' ||
        perfil.ckavancar === 'S' ||
        perfil.ckretornar === 'S'
    );
}

async function lerDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        const reqPerfilEtapa = await Api.genericPost('/listas/proc/perfil/etapa', {
            idep: globalStore.idep,
            idreferencia: props.idEtapa
        });

        lsPerfil.value = (reqPerfilEtapa || []).map(p => ({
            ...p,
            ckanalise_documentos: normalizarCheck(p.ckanalise_documentos),
            ckanexar_doc: normalizarCheck(p.ckanexar_doc),
            ckavancar: normalizarCheck(p.ckavancar),
            ckconsultar: normalizarCheck(p.ckconsultar),
            ckinserir_dados: normalizarCheck(p.ckinserir_dados),
            ckretornar: normalizarCheck(p.ckretornar)
        }));

    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}

async function salvarDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        for (const perfil of lsPerfil.value){
            const temPermissao = possuiAlgumaPermissao(perfil);
            const jaPossuiVinculo = Number(perfil.idusuario_perfil || 0) > 0;
            
            if (temPermissao){
                await Api.genericPut('/cad/proc_modelo_etapa_perfil',{
                    idproc_modelo_etapa: props.idEtapa,
                    idusuario_perfil: perfil.idperfil,
                    ckanalise_documentos: perfil.ckanalise_documentos,
                    ckavancar: perfil.ckavancar,
                    ckanexar_doc: perfil.ckanexar_doc,
                    ckconsultar: perfil.ckconsultar,
                    ckinserir_dados: perfil.ckinserir_dados,
                    ckretornar: perfil.ckretornar,
                    idlogin: globalStore.idlogin,
                });
            } else if (jaPossuiVinculo) {
                await Api.genericPost('/cad/exec_requisicao', {
                    nmrequisicao: "revogar_proc_modelo_etapa_perfil",
                    intparam1: props.idEtapa,
                    intparam2: perfil.idperfil,
                    idlogin: globalStore.idlogin
                });
            }

        }
        emit('close');
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}

onMounted(lerDados);
</script>


<style scoped>
.proc-permissoes-grid {
    display: grid;
    grid-template-columns: minmax(180px, 1.5fr) repeat(6, minmax(90px, 1fr));
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 12px;
}

.proc-permissoes-header {
    font-weight: 600;
    font-size: 13px;
    text-align: center;
    background: #f5f5f5;
    padding: 10px 8px;
    border-bottom: 1px solid #ddd;
}

.proc-permissoes-header.perfil {
    text-align: left;
}

.proc-permissoes-cell {
    padding: 9px 8px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: center;
}

.proc-permissoes-cell.perfil {
    justify-content: flex-start;
    font-weight: 500;
}

.proc-permissoes-cell input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.alert-error {
    margin-top: 10px;
    padding: 10px;
    border-radius: 6px;
    background: #ffe6e6;
    color: #8a0000;
}
</style>